import Vue from 'vue'
import { ajax, interceptors, setOpt } from './ajax.js'
import AutoTable from './auto-table'
import validate from './validate'
import importFun from './import' // 导入文件
import Upload from './upload' // 多文件上传
import UploadSingle from './upload-single' // 单文件上传
import RemoteSelect from './remote-select' // 远程搜索
import RemoteSelectOpt from './remote-select-opt' // 远程搜索2

Vue.prototype.$validate = validate // 验证

AutoTable(Vue)
Vue.use(importFun)
Vue.use(Upload)
Vue.use(UploadSingle)
Vue.use(RemoteSelect)
Vue.use(RemoteSelectOpt)
export {ajax, interceptors, setOpt}



// WEBPACK FOOTER //
// ./src/components/mc-ui/index.js